var exports = {
  "k": "x112a1f60--f90045--container",
};

module.exports = exports;
